import { ENV_CONFIG, BACKUP_DOWNLOADER_SERVER } from '@/config/envs'
import Storage from '@/utils/Storage'

export default {
  computed: {
    downloadUrl() {
      const { videoId, qualityToBeDownloaded } = this
      let downloadServer = Storage.getItem('downloaderServer')

      if (!downloadServer) {
        downloadServer = BACKUP_DOWNLOADER_SERVER
      }

      let subdomain = `download-${downloadServer}`
      let port = '7443'
      let path = 'download'

      if (ENV_CONFIG !== 'production') {
        subdomain = `download-staging-${downloadServer}`
        port = '7442'
      }

      if (qualityToBeDownloaded) {
        path = `${qualityToBeDownloaded}/download`
      }

      return `https://${subdomain}.pandavideo.com:${port}/videos/${videoId}/${path}`
    },
    downloadAudioUrl() {
      const { videoId } = this
      let downloadServer = Storage.getItem('downloaderServer')
      if (!downloadServer) {
        downloadServer = BACKUP_DOWNLOADER_SERVER
      }
      let subdomain = `download-${downloadServer}`
      let port = '7443'
      let path = 'download'
      if (ENV_CONFIG !== 'production') {
        subdomain = `download-staging-${downloadServer}`
        port = '7442'
      }
      if (videoId) {
        path = `${videoId}/download`
      }
      return `https://${subdomain}.pandavideo.com:${port}/audios/${path}`
    },
  },
  methods: {
    downloadDubUrl(videoId, qualityToBeDownloaded, lang) {
      let downloadServer = Storage.getItem('downloaderServer')

      if (!downloadServer) {
        downloadServer = BACKUP_DOWNLOADER_SERVER
      }

      let subdomain = `download-${downloadServer}`
      let port = '7443'
      let path = 'download'

      if (ENV_CONFIG !== 'production') {
        subdomain = `download-staging-${downloadServer}`
        port = '7442'
      }

      if (qualityToBeDownloaded) {
        path = `${qualityToBeDownloaded}/download`
      }
      if (lang) {
        path += `?lang=${lang}`
      }

      return `https://${subdomain}.pandavideo.com:${port}/videos/${videoId}/${path}`
    },
  },
}
